import API from '@/services/api'
import handleError from '@/services/handleError'
import { RETURN_SUCCESS_LIST } from '@/constants.js'

const HOME_LAST_TRANSACTION_ID_STORAGE_KEY = 'energy2go.home.lastTransactionId'
const LEGACY_LAST_TRANSACTION_ID_STORAGE_KEY = 'lastTransaction'

export default async function getLastTransaction() {
  try {
    const response = await API.get('/transaction/last_rent')
    const STATUS_CODE = 400
    if (response.status >= STATUS_CODE) {
      console.log('Não foi possível obter a última transação')
      return
    }
    if (response && response.data) {
      const lastTransaction = response.data

      const now = new Date().getTime()
      const MILLISECONDS_PER_SECOND = 1000
      const past = now - lastTransaction.elapsed_time * MILLISECONDS_PER_SECOND
      const freeTime = lastTransaction.free_time * MILLISECONDS_PER_SECOND

      lastTransaction['on_free_time'] = false
      lastTransaction['next_payment'] = 0
      if (now - past < freeTime) {
        lastTransaction['on_free_time'] = true
        lastTransaction['next_payment'] = Math.floor((freeTime - (now - past)) / MILLISECONDS_PER_SECOND)
      }

      lastTransaction.batteryReturned = false
      if (lastTransaction.status === 'take_battery_success') {
        localStorage.setItem(HOME_LAST_TRANSACTION_ID_STORAGE_KEY, lastTransaction.id)
      }

      const persistedLastTransactionId =
        parseInt(localStorage.getItem(HOME_LAST_TRANSACTION_ID_STORAGE_KEY)) ||
        parseInt(localStorage.getItem(LEGACY_LAST_TRANSACTION_ID_STORAGE_KEY))

      if (persistedLastTransactionId === lastTransaction.id && RETURN_SUCCESS_LIST.includes(lastTransaction.status)) {
        lastTransaction.batteryReturned = true
      }
      return lastTransaction
    } else {
      return {
        on_free_time: false,
        next_payment: 0,
        batteryReturned: false,
        status: null,
        id: null,
        token: null,
        elapsed_time: 0,
        free_time: 0,
        return_point: null
      }
    }
  } catch (error) {
    handleError(error)
    return
  }
}
